import * as React from 'react';

import { translate } from '~l10n/client';

import { toNumber, toPrecision } from '~shared/utils/number';

interface QuestionPointsProps {
  isHidden?: boolean;
  weight: number;
}

/**
 * Display the number of points a question is worth. Explicitly converting to
 * a number for now, since `toPrecision` returns a string.
 */
export function QuestionPoints({ isHidden, weight }: QuestionPointsProps) {
  if (isHidden) return null;

  const points = toNumber(toPrecision(weight, 2));
  const text =
    points === 1
      ? translate('1 point')
      : translate('{0} points').format(points);

  return (
    <div className="grid grid-cols-question-fields-question-editor max-w-5xl p-0">
      <div className="col-start-3 ml-2">
        <span className="text-xs font-600 leading-6 text-blue-900 uppercase">
          {text}
        </span>
      </div>
    </div>
  );
}
